import { analog_bjt } from './analog_bjt';

export class bcp5310mtwg extends analog_bjt {}
